import Vue from "vue";

import AppLayout from "./app";
import DefaultLayout from "./default";

Vue.component("app-layout", AppLayout);
Vue.component("default-layout", DefaultLayout);
